import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';

@Component({
    selector: 'schema-item',
    template: require('./schema-item.component.html'),
    styles: [require('./schema-item.component.scss')]
})

export class SchemaItemComponent {

    @Input() public schema;
    @Input() public showSettings: boolean = false;
    @Input() public showRemove: boolean = false;
    @Input() public showCheckbox: boolean = false;
    @Input() public isDisabled: boolean = false;
    @Input() public hasVersionToRm;

    @Output() public onRemoveSchema = new EventEmitter();
    @Output() public onTest = new EventEmitter();

    private htmlConn: string;
    private databaseType: string;

    constructor(private store: Store, @Inject('$state') public state: any,
                private dialogManagerService: DialogManagerService) {
        this.databaseType = this.state.params.dbType || this.store.getState().projects.projectWithMetaData.dbTypeId.toString();
    }
    public schemaSettings(schema): void {
        this.store.dispatch({
            type: 'GET_CONN_TEMPLATE',
            payload: { dbTypeId: this.databaseType, manageOrUnmanage: 'managed' }
        }).then((res) => {
            this.htmlConn = res.htmlTemplate;
            const con = { ...schema.connectionProperties };
            this.dialogManagerService.showDBConnectionDialog(
                this.htmlConn,
                {
                    title: res.title,
                    buttons: [
                        { text: 'OK', onClick: (instance, onClose) => { onClose(instance.data); } },
                        { text: 'Cancel', onClick: (_, onClose) => { onClose(); } }
                    ],
                    setData: (instance) => {
                        instance.data = {
                            connectionProperties: con,
                            dbType: this.databaseType,
                            hasVersionToRm: this.hasVersionToRm,
                            isManaged: schema.isManaged,
                            testButton: {
                                value: 'Test Connection', onClick: (data) => {
                                    // instead of ng-init data.connectionProperties.authType = data.authType.id
                                    data.connectionProperties.authType = data.authType.id.toString();
                                    data.schema = this.schema;
                                    data['status_test_schema'] = '';
                                    this.onTest.emit(data);
                                }
                            },
                            switchTab: (data, tab) => {
                                // instead of ng-init data.connectionProperties.lastVisit = "Properties"
                                if (!data.connectionProperties.lastVisit) {
                                    data.connectionProperties.lastVisit = 'Properties';
                                }
                                // instead of ng-init data.connectionProperties.authType = data.authType.id
                                // data.connectionProperties.authType = data.authType.id.toString();
                                data.connectionProperties.authType = data.authType.id.toString();
                                const con = data.connectionProperties;

                                this.store.dispatch({
                                    type: 'SWITCH_TAB',
                                    payload: { dbTypeId: this.databaseType, connectionProperties: con }
                                }).then((res) => {
                                    if (res) {
                                        data.connectionProperties = res;
                                        data.connectionProperties.lastVisit = tab;
                                    }
                                });
                            }
                        };
                    }
                },
                (data) => {
                    schema.schemaName =  data.connectionProperties.dbName || data.connectionProperties.userName;
                    data.connectionProperties.authType = data.authType.id.toString();
                    schema.connectionProperties = data.connectionProperties;

                }
            );
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/schema-item/schema-item.component.ts